import { ProductVariation } from 'models/productsReferential';
import { useEffect, useState } from 'react';

interface UseKeyboardNavigationProps {
  products: ReadonlyArray<ProductVariation>;
  onSelect: (product: ProductVariation) => void;
  search: string;
}

export function useKeyboardNavigation({ products, search, onSelect }: UseKeyboardNavigationProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (search) {
      setCurrentIndex(0);
    }
  }, [search]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!products.length) {
        return;
      }
      if (e.key === 'ArrowDown') {
        setCurrentIndex(idx => (idx + 1) % products.length);
        e.preventDefault();
      } else if (e.key === 'ArrowUp') {
        setCurrentIndex(idx => (idx - 1 + products.length) % products.length);
        e.preventDefault();
      } else if (e.key === 'Enter') {
        onSelect(products[currentIndex]);
        e.preventDefault();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentIndex, products, products.length, onSelect]);

  return currentIndex;
}
